import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../actions/modal';
import Tooltip from '@mui/material/Tooltip';

const CustomModal = (props) => {
    const dispatch = useDispatch();
    const { modalComponent, heading, modalWidth, modalHeight } = useSelector(store => store.modalreducer)
    const closeModal = () => { dispatch(closeModalAction()) }
    return (
        <>
        <div className="opacity-25 fixed inset-0 z-50 bg-black"></div>
            <div className="justify-center  items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative mb-6 mt-12 mx-auto" >
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-center justify-between py-6 px-7 border-b  border-scogoddd rounded-t-10px w-full">
                            <h3 className="text-3xl font-medium text-scogo15 modelHeading">
                                {heading}
                            </h3>
                            <div className="ml-auto cursor-pointer" onClick={() => { closeModal() }} >
                                <Tooltip title='Close' placement="bottom">
                                    <span className="material-icons text-scogoprimary font-medium align-middle text-3xl hover:text-scogoorange" >
                                         highlight_off
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <div >
                            <div className='h-full overflow-y-auto modalComponent' style={{ 'height': `${modalHeight ? modalHeight : '65vh'}`, 'width': `${modalWidth ? modalWidth : '60rem'}`, maxHeight: '65vh' }}>
                                {modalComponent && modalComponent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default CustomModal
